import React, { useState } from 'react';
import { Button, Drawer, makeStyles } from '@material-ui/core'
import { COLOR_BACKGROUND_WARM, COLOR_MIDDLE_GRAY } from "../styles/colors";
import EvaluationDrawerContent from '../molecules/EvaluationDrawerContent';
import { UserState } from '../redux/reducers/user';
import { State } from '../redux/reducers';
import { connect } from 'react-redux';
import { PlayerEvaluationDataResponse, ProgramEvaluationSchema } from '../types/Evaluation';
import gql from '../services/gql';
import Player from '../types/Player';
import { useQuery } from '@tanstack/react-query';
import Team from '../types/Team';

const useStyles = makeStyles(theme => ({
  indicator: {
    display: 'none',
  },
  evaluationBtn: {
    border: `2px solid ${COLOR_MIDDLE_GRAY}`,
    borderRadius: '30px',
    boxShadow: 'none',
    backgroundColor: COLOR_BACKGROUND_WARM,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    textTransform: 'initial',

    '&:hover': {
      backgroundColor: COLOR_BACKGROUND_WARM,
      boxShadow: 'none',
      fontWeight: 800,
      padding: `${theme.spacing(1.5)}px ${theme.spacing(2.825)}px`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'center',
      justifyContent: 'space-between',
    },
  },
  evaluationReportDrawer: {
    width: '100%',
    maxWidth: 535,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  evaluationReportDrawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  evaluationReportDrawerHeaderTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 600,
  },
  evaluationReportDrawerHeaderCloseButton: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
}), { name: Evaluation.name });

interface EvaluationProps {
  user: UserState;
  programEvaluationDataSchema?: ProgramEvaluationSchema;
  player?: Player;
}

export function Evaluation(props: EvaluationProps) {
  const {
    programEvaluationDataSchema,
    player,
    user
  } = props;
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const hasProgramEvaluationSchema = Boolean(
    programEvaluationDataSchema
    && Array.isArray(programEvaluationDataSchema.customTabs)
    && programEvaluationDataSchema.customTabs.length > 0,
  );

  const { data: playerEvaluationData, isLoading, refetch: refetchPlayerEvaluationData } = useQuery<PlayerEvaluationDataResponse | null>(
    ['playerEvaluationData', player?.id],
    () => gql(`
      getPlayerEvaluationData (playerId: ${player?.id || 0}) {
        accountName
        playerCode
        customFields
      }
    `)
      .then((data:any) => data.getPlayerEvaluationData as PlayerEvaluationDataResponse),
    {
      enabled: drawerOpen && !!player?.id,
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  );

  const { data: evaluationTeam, isLoading: isEvaluationLoading } = useQuery<Team | null>(
    ['evaluationTeam', user?.program?.programTeamId],
    () => gql(`
            team (id: ${user?.program?.programTeamId}) {
              name
              logo247
              logoESPN
              logoAlt
            }
          `)
          .then((data: any) => data.team as Team),
    {
      enabled: !!user?.program?.programTeamId,
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  );

  function onClose() {
    setDrawerOpen(false);
  }

  return (
  <div>
    {hasProgramEvaluationSchema && (
      <Button variant="contained"
        className={classes.evaluationBtn}
        endIcon={
          <img
            src={evaluationTeam?.logo247 || evaluationTeam?.logoESPN || ''}
            alt={evaluationTeam?.name || 'Team Logo'}
            width={20}
            height={20}
          />
        }
        onClick={() => setDrawerOpen(true)}
      >
        Evaluation
      </Button>
    )}
    <Drawer
      classes={{ paper: classes.evaluationReportDrawer }}
      anchor='right'
      open={drawerOpen}
      onClose={onClose}
    >
      <EvaluationDrawerContent
        playerEvaluationData={playerEvaluationData}
        programEvaluationDataSchema={programEvaluationDataSchema}
        player={player}
        isLoading={isLoading}
        onRefetchPlayerEvaluationData={refetchPlayerEvaluationData}
        onClose={onClose}
        evaluationTeam={evaluationTeam}
      />
    </Drawer>
  </div>
  );
};



const mapStateToProps = (state:State) => {
  const userState = state.user as UserState;

  return {
    user: state.user,
    programEvaluationDataSchema: userState.programEvaluationDataSchema,
  };
};

export default connect(mapStateToProps)(Evaluation);
